import { useCallback } from "react";
import { SquiggleItem } from "../types/types";
import backend from "../backend";

export const useItemStatusGlue = (
  adventureId: string,
  refreshAll: () => void
) => {
  const toggleArchiveItem = useCallback((item: SquiggleItem) => {
    (async () => {
      const archiveResponse = await backend.archiveItem(adventureId, item.id, !item.archived);
      if (!archiveResponse.ok) {
        return;
      }
      refreshAll();
    })();
  }, [adventureId, refreshAll]);

  const toggleStarItem = useCallback((item: SquiggleItem) => {
    (async () => {
      const starResponse = await backend.starItem(adventureId, item.id, !item.starred);
      if (!starResponse.ok) {
        return;
      }
      refreshAll();
    })();
  }, [adventureId, refreshAll]);
  
  return { toggleArchiveItem, toggleStarItem };
};